import { ComponentType, OverlayRef } from '@angular/cdk/overlay';
import { ISidePanelRef } from './side-panel-ref.interface';

export interface ISidePanelInstance {
  component?: ComponentType<any>;
  overlay: OverlayRef;
  resolve?: (result?: any) => void;
  reject?: (error?: any) => void;
  onClose?: (res?: any) => Promise<any>;
  sidePanelRef?: ISidePanelRef;
  onClosePromise?: Promise<any>;
}
